import { ButtonTertiary } from '@spotify-internal/encore-web/core';
import styled, { css } from 'styled-components';
export const MenuButton = styled(ButtonTertiary) `
  padding: 0;
  color: ${props => props.theme.text};

  &:focus-visible {
    outline-width: 1px;
    outline-style: auto;
  }
  ${({ color }) => color &&
    css `
      color: ${color};
    `}

  &:hover {
    color: ${props => props.theme.text};
    cursor: pointer;
    ${({ color }) => color &&
    css `
        color: ${color};
      `}
  }

  &::after {
    display: none;
  }
`;
//# sourceMappingURL=MenuButton.js.map